const env = window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
    return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
} );

function getURL( url ) {
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const idURL = getURL( 'https://(env.)api.biw.cloud/v1/id' );
export const rosterUrl = getURL( 'https://(env.)api.biw.cloud/v1/roster' );
export const cashierUrl = getURL( 'https://(env.)api.biw.cloud/v1/cashier' );
export const privacyDownloadUrl = getURL( 'https://(env.)api.biw.cloud/privacyapi/public/services/v1/files/download' ); // /:companyId/:solutionId/:locale
